/**
 * Admin Portal Routes (root paths, no /admin prefix).
 */

// Route definitions for App (relative to dashboard)
export const ROUTE_DEF_HOME = "/";
export const ROUTE_DEF_LOGIN = "login";
export const ROUTE_DEF_ADD_ADMIN_USER = "add-admin-user";
export const ROUTE_DEF_ADMIN_USERS = "admin-users";
export const ROUTE_DEF_ADMIN_USER_DETAIL = "admin-users/:userId";
export const ROUTE_DEF_MEMBERSHIP = "membership";
export const ROUTE_DEF_PLANS = "plans";
export const ROUTE_DEF_PLAN_DETAIL = "plans/:planId";
export const ROUTE_DEF_FEATURES = "features";
export const ROUTE_DEF_FEATURE_DETAIL = "features/:featureCode";
export const ROUTE_DEF_PLAN_PRICING = "plan-pricing";
export const ROUTE_DEF_PLAN_PRICING_DETAIL =
  "plan-pricing/:planId/:planPricingId";
export const ROUTE_DEF_BILLING_CYCLES = "billing-cycles";
export const ROUTE_DEF_BILLING_CYCLE_DETAIL = "billing-cycles/:billingCycleId";
export const ROUTE_DEF_SUBSCRIPTIONS = "subscriptions";
export const ROUTE_DEF_SUBSCRIPTION_DETAIL = "subscriptions/:subscriptionId";
export const ROUTE_DEF_PAYMENTS = "payments";
export const ROUTE_DEF_PAYMENT_DETAIL = "payments/:paymentId";
export const ROUTE_DEF_ORDER_SUMMARY = "order-summary";
export const ROUTE_DEF_CHECKOUT = "checkout";
export const ROUTE_DEF_SUCCESS = "success";

// Absolute paths for navigation (dashboard = /dashboard, login at root)
export const ROUTE_HOME = "/dashboard";
export const ROUTE_LOGIN = "/login";
export const ROUTE_PLANS = "/dashboard/plans";
export const ROUTE_SUBSCRIPTIONS = "/dashboard/subscriptions";
export const ROUTE_PAYMENTS = "/dashboard/payments";
export const ROUTE_ORDER_SUMMARY = "/dashboard/order-summary";
export const ROUTE_CHECKOUT = "/dashboard/checkout";
export const ROUTE_SUCCESS = "/dashboard/success";
export const ROUTE_COMPANIES = "/dashboard/companies";
export const ROUTE_COMPANY_DETAIL = "/dashboard/companies/:companyId";
export const ROUTE_BILLING_CYCLES = "/dashboard/billing-cycles";
export const ROUTE_FEATURES = "/dashboard/features";
export const ROUTE_MEMBERSHIP = "/dashboard/membership";
export const ROUTE_ADD_ADMIN_USER = "/dashboard/add-admin-user";
export const ROUTE_ADMIN_USERS = "/dashboard/admin-users";
export const ROUTE_ADMIN_USER_DETAIL = "/dashboard/admin-users/:userId";

// Helper functions to build paths with IDs
export const getPlanDetailPath = (planId: string) =>
  `/dashboard/plans/${planId}`;
export const getSubscriptionDetailPath = (subscriptionId: string) =>
  `/dashboard/subscriptions/${subscriptionId}`;
export const getPaymentDetailPath = (paymentId: string) =>
  `/dashboard/payments/${paymentId}`;
export const getCompanyDetailPath = (companyId: string) =>
  `/dashboard/companies/${companyId}`;
export const getFeatureDetailPath = (featureCode: string) =>
  `/dashboard/features/${encodeURIComponent(featureCode)}`;
export const getBillingCycleDetailPath = (billingCycleId: string) =>
  `/dashboard/billing-cycles/${encodeURIComponent(billingCycleId)}`;
export const getPlanPricingDetailPath = (
  planId: string,
  planPricingId: string,
) =>
  `/dashboard/plan-pricing/${encodeURIComponent(planId)}/${encodeURIComponent(planPricingId)}`;
export const getAdminUserDetailPath = (userId: string) =>
  `/dashboard/admin-users/${encodeURIComponent(userId)}`;
